













import { defineComponent, onMounted, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useEmailVerification from "@/hooks/useEmailVerification";
import providers from "@/lib/api";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BasePage from "@/components/BasePage";
import SignUpEmailConfirmCode from "@/components/SignUpEmailConfirmCode";
import ConfirmCodeView from "./components/ConfirmCodeView.vue";
import WelcomeConfirm from "./components/WelcomeConfirm.vue";

export default defineComponent({
  name: "PageEmailConfirmCode",
  components: { WelcomeConfirm, ConfirmCodeView, SignUpEmailConfirmCode, BasePage },
  props: {
    code: { type: String },
  },
  setup(props, { root }) {
    const { authUserStrict, authUser } = useAuthUser();
    const { startPeriodicalConfirmationCheck, setUserVerificationStatus } = useEmailVerification();

    const loading = ref(false);
    const success = ref(false);
    const showWelcomeConfirm = ref(false);

    const onLogout = () => {
      root.$router.push({ name: "logout" });
    };
    const onContinue = () => {
      root.$router.push(getProfileUrl(authUserStrict.value));
    };

    const onBecomeCreator = () => {
      root.$router.push({ name: "profilePayeeInfo" });
    };
    const onLogin = () => {
      if (config.featureWelcomeToSite && !config.featureHideBecomeCreator && !config.featureSoloModel) {
        showWelcomeConfirm.value = true;
      } else {
        onContinue();
      }
    };

    const onErrorQueryCode = () => {
      root.$router.replace({ name: "home" });
    };

    const sendConfirmationCode = async () => {
      if (!props.code) return;
      try {
        loading.value = true;
        success.value = await providers.EmailVerificationProvider.verifyByLongCode({ code: props.code });
        if (authUser.value && success.value) {
          await setUserVerificationStatus(success.value);
        }
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      if (!props.code) {
        startPeriodicalConfirmationCheck(onLogin);
      } else {
        sendConfirmationCode();
      }
    });

    return {
      loading,
      success,
      showWelcomeConfirm,
      onLogout,
      onLogin,
      onErrorQueryCode,
      onContinue,
      onBecomeCreator,
    };
  },
});
